import { v4 as uuid } from "uuid";
import {Model} from "../base/Model";
import {Collection} from "../base/Collection";
import { CompanyModel } from "./Company";

enum GenderEnum {
  female = "F",
  male = "M",
  other = "U",
}


export class HumanModel extends Model  {
    key: string = "";
    initials: string = "";
    first_name: string = "";
    preposition: string = "";
    last_name: string = "";
    gender: GenderEnum = GenderEnum.other;
    email: string = "";
    phone: string = "";
    mobile: string = "";
    type:number = 0;
    company:CompanyModel|null = null;

    constructor(data = null, usertype = null) {
        super(data);
        
        if(data) {
            this.createModel(data);
            
        }
    }

    public addCompany() {
        let company:CompanyModel = new CompanyModel();

        return company;

    }
}
